const Blog = () => {
    return ( 
        <div>
            <h1>This blog is still in development!</h1>
        </div>
     );
}
 
export default Blog;